<script lang="ts">
  import svelteLogo from './assets/svelte.svg'
  import viteLogo from '/vite.svg'
  import {store} from './store/store'
    import JobResult from './lib/JobResult.svelte';

  const BASE_URL = /*"http://localhost:3581"*/ "https://funke-ci.6579574.xyz";

  let pw_input = "";
  let admin_user_input = "";
  let admin_pw_input = "";

  let currentPage = "home";

  let variables = [];

  let newVar = {
    name: "",
    value: ""
  }

  let editVariable = -1;

  let tasks = [];

  let taskRequests = [];

  let runningTask = null;

  async function fetchVariables() {
    if($store.pw == null) return;

    const variablesReq = await fetch(`${BASE_URL}/variable`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `${$store.pw}`
      }
    });

    if(!variablesReq.ok) {
      console.log("Error fetching variables");
      return;
    }

    variables = await variablesReq.json();
  }

  async function fetchTasks() {
    if($store.pw == null) return;

    const taskReq = await fetch(`${BASE_URL}/task`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `${$store.pw}`
      }
    });

    if(!taskReq.ok) {
      console.log("Error fetching tasks");
      return;
    }
    tasks = await taskReq.json();

    const taskRequestsReq = await fetch(`${BASE_URL}/task/request`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `${$store.pw}`
      }
    });

    if(!taskRequestsReq.ok) {
      console.log("Error fetching task requests");
      return;
    }
    taskRequests = await taskRequestsReq.json();

    const runningReq = await fetch(`${BASE_URL}/task/running`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `${$store.pw}`
      }
    });

    if(!runningReq.ok) {
      console.log("Error fetching running task");
      return;
    }
    runningTask = await runningReq.json();

    if(runningTask != null) {
      setTimeout(() => fetchData(currentPage), 5000);
    }
  }

  async function fetchData(currentPage: string) {
    if($store.pw == null) return;

    if(currentPage == "variables") {
      await fetchVariables();
    } else if(currentPage == "jobs") {
      await fetchTasks();
    }
  }

  async function setVariable(variable) {
    if($store.pw == null) return;

    let url = "";
    if(variable.name.startsWith("secrets.")) {
      variable.name = variable.name.replace("secrets.", "");
      url = "secret"
    } else {
      variable.name = variable.name.replace("vars.", "");
      url = "variable"
    }

    const updateReq = await fetch(`${BASE_URL}/${url}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `${$store.pw}`
      },
      body: JSON.stringify(variable)
    });

    if(!updateReq.ok) {
      console.log("Error updating variable");
      return;
    }

    editVariable = -1;

    await fetchData(currentPage);
  }

  async function approveTask(id: number) {
    await fetch(`${BASE_URL}/task`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `${$store.pw}`
      },
      body: JSON.stringify({username: $store.adminUser, password: $store.adminPw, content: id})
    });
    
    await fetchData(currentPage);
  }

  $: fetchData(currentPage);
</script>

<main>
  {#if $store.pw == null}
    <div>
      <input type="password" bind:value={pw_input} />
      <button on:click={() => store.set({pw: pw_input, adminUser: null, adminPw: null})}>Submit</button>
    </div>
  {:else}
  {#if $store.adminPw == null}
    <h2>Sign in as admin</h2>
    <input type="text" bind:value={admin_user_input} />
    <input type="password" bind:value={admin_pw_input} />
    <button on:click={() => store.set({pw: $store.pw, adminUser: admin_user_input, adminPw: admin_pw_input})}>Signin</button>
  {/if}
    <div class="nav">
      <button on:click={() => currentPage = "home"}>Home</button>
      <button on:click={() => currentPage = "variables"}>Variables</button>
      <button on:click={() => currentPage = "jobs"}>Jobs</button>
    </div>
    {#if currentPage == "variables"}
      <div>
        <h1>Variables</h1>
        <input type="text" bind:value={newVar.name} />
        <input type="text" bind:value={newVar.value} />
        <button on:click={() => setVariable(newVar)}>Save</button>

        <table class="var-container">
          <tr>
            <th>Name</th>
            <th>Value</th>
            <th>Actions</th>
          </tr>
          {#each variables as variable, index}
          <tr class="var">
            {#if editVariable == index}
              <td>{variable.name}</td>
              <td><input type="text" bind:value={variable.value} /></td>
              <td>
                <button on:click={() => setVariable(variable)}>Save</button>
                <button on:click={() => editVariable = -1}>Cancel</button>
              </td>
            {:else}
              <td class="var-name">{variable.name}</td>
              <td class="var-val">{variable.value}</td>
              <td> <button on:click={() => editVariable = index}>Edit</button></td>
            {/if}
          </tr>
          {/each}
        </table>
      </div>
    {:else if currentPage == "jobs"}
      {#if runningTask != null}
      <div>
        <h2>Running Task {runningTask.id}</h2>

        <div class="task-container">
          {#each runningTask.jobs as job} 
            <div class="job">
              <h3>{job.done} / {job.steps} done</h3>
              {#if job.output != null}
                <JobResult result={job.output} />
              {/if}
            </div>
          {/each}
        </div>
      </div>
      {/if}
      {#if taskRequests != null &&taskRequests.length > 0}
      <div>
        <h2>Task Requests</h2>
        <div class="task-container">
          {#each taskRequests as taskRequest}
            <div class="task">
              <h3>{taskRequest.id}</h3>
              <span>{taskRequest.commit}</span>
              {#if $store.adminPw != null}
              <button on:click={() => approveTask(taskRequest.id)}>Approve & Start</button>
              {/if}
            </div>
          {/each}
        </div>
      </div>
      {/if}
      
    {/if}
  {/if}
</main>

<style>
  .logo {
    height: 6em;
    padding: 1.5em;
    will-change: filter;
    transition: filter 300ms;
  }
  .logo:hover {
    filter: drop-shadow(0 0 2em #646cffaa);
  }
  .logo.svelte:hover {
    filter: drop-shadow(0 0 2em #ff3e00aa);
  }
  .read-the-docs {
    color: #888;
  }
</style>
